// Hook de session serveur : vérifie l'identité via GET /auth/me et expose
// login/logout. Aucun document utilisateur n'est stocké côté client ; seuls
// les DTO du back et le cookie httpOnly matérialisent la session.
import { useEffect, useState, useCallback, useMemo } from "react";
import { authApi } from "../api/auth";

const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { status, data } = await authApi.me();
      if (status === 200 && data.user) {
        setUser(data.user);
        setError(null);
      } else {
        setUser(null);
      }
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const { status, data } = await authApi.login({ email, password });
      if (status === 200 && data.user) {
        setUser(data.user);
        setError(null);
        return { ok: true };
      }
      setError(data.message || "Identifiants invalides.");
      return { ok: false, status, message: data.message };
    } catch (e) {
      setError("Identifiants invalides.");
      return { ok: false, message: "Identifiants invalides." };
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await authApi.logout();
    } finally {
      setUser(null);
    }
  }, []);

  const value = useMemo(
    () => ({ user, loading, error, login, logout, refresh }),
    [user, loading, error, login, logout, refresh]
  );

  return value;
};

export default useAuth;
